<script lang="tsx">
  import { defineComponent } from 'vue'
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import { BeerStyleObj } from '@xhs/yam-beer/core'
  import initStyle from './style'

  initStyle()

  type BeerDividerProps = {
    bs: BeerStyleObj
    hairLine: boolean
    contentPosition: 'center' | string
    contentOffset: string
    contentBs: BeerStyleObj
  }

  export default defineComponent({
    name: 'BeerDivider',
    props: {
      /**
       * 是否垂直方向
       * @type {true|false}
       */
      vertical: {
        type: Boolean,
        default: false,
      },
      /**
       * 强制分割线高度/宽度为 0.5px
       * @type {true|false}
       */
      hairLine: { // 0.5px
        type: Boolean,
        default: false,
      },
      /**
       * 是否虚线
       *
       * 注意，hairLine 会让虚线样式看不清，不要组合使用
       * @version 4.1.0
       */
      dashed: {
        type: Boolean,
        default: false,
      },
      /**
       * 设置文本内容是否居中
       *
       * 功能与antD的orientation相同
       */
      contentPosition: {
        type: String,
        default: 'center',
      },
      /**
       * 设置文本内容水平位置偏移像素，如 10px
       */
      contentOffset: {
        type: String,
        default: '',
      },
      /**
       * @ignore
       * 容器 bs style
       * @see style
       */
      bs: {
        type: Object,
        default: () => ({}),
      },
      /**
       * @ignore
       * 文本内容样式
       * @see style
       */
      contentBs: {
        type: Object,
        default: () => ({}),
      },
    },
    setup(props, { slots }) {
      return () => {
        const vbs: BeerDividerProps['bs'] = {
          'cmp.divider': 'wrapper',
          ...(props.dashed ? {
            backgroundImage: 'linear-gradient(90deg, #e8e8e8, #e8e8e8 75%, transparent 75%, transparent 100%)',
            backgroundSize: '20px 1px',
          } : {
            bg: 'palette.grey3.base',
          }),
          ...props.bs,
        }
        if (props.hairLine) {
          vbs['cmp.divider.wrapper'] = 'hairline'
        }
        if (slots.default) {
          vbs['.divier-content'] = {
            'cmp.divider': 'content',
            transform: !props.contentOffset ? 'translateY(-50%)' : `translateY(-50%) translateX(${props.contentOffset})`,
            ...props.contentBs,
          }
          if (props.contentPosition === 'center') {
            vbs.textAlign = 'center'
          }
        }
        return (
        <NewBsBox class="divier-container" bs={vbs} context={props}>
          <div class="divier-content">
            {slots.default?.()}
          </div>
        </NewBsBox>
      )
      }
    },
  })
</script>
